import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import Button from '@material-ui/core/Button';
import s from './Widgets.css';
import Link from '../../components/Link';
import WidgetIcon from '../../components/WidgetIcon';
import { CATEGORIES, getWidgetsByCategory } from '../../data/widgets';
import { CHROME_STORE_URL } from '../../utils/seo';

/**
 * Хаб каталога виджетов: /widgets
 * Сгруппирован по категориям, каждая карточка ведёт на свой лендинг.
 */
function Widgets() {
	return (
		<div className={s.root}>
			<p className={s.intro}>
				These are the widgets for Chrome’s new tab that come with New
				Tab Studio: what each one does, how it’s set up, and when it’s
				worth the space. Free gets you three added by hand. Widgets that
				arrive with an installed theme don’t count towards that, and PRO
				removes the limit entirely.
			</p>

			{CATEGORIES.map(category => (
				<section className={s.category} key={category.key}>
					<div className={s.label}>{category.key}</div>
					<h2>{category.title}</h2>
					<p className={s.categoryIntro}>{category.intro}</p>

					<div className={s.grid}>
						{getWidgetsByCategory(category.key).map(widget => (
							<Link
								className={s.tile}
								key={widget.slug}
								to={`/widgets/${widget.slug}`}
							>
								<span className={s.tileHead}>
									<WidgetIcon
										slug={widget.slug}
										category={widget.category}
									/>
									<h3>{widget.name}</h3>
									{widget.plan === 'pro' && (
										<span className={s.badge}>PRO</span>
									)}
								</span>
								<p>{widget.metaDescription}</p>
							</Link>
						))}
					</div>
				</section>
			))}

			<section className={s.category}>
				<h2>Questions about widgets for Chrome</h2>

				<div className={s.faqItem}>
					<h3>Is there a free widget app for Chrome?</h3>
					<p>
						Yes. New Tab Studio puts widgets on Chrome’s new tab for
						free: every widget on this page is on the free plan, and
						you can add three by hand. Widgets that come with an
						installed theme don’t count towards the three, so a
						ready-made page can carry many more.
					</p>
				</div>

				<div className={s.faqItem}>
					<h3>What widgets can I put on the Chrome new tab?</h3>
					<p>
						With New Tab Studio, 35 of them: countdowns and clocks,
						a to-do list, notes, a habit tracker, a Pomodoro timer,
						weather, news, a calendar, bookmarks, a search bar and
						more. Each is dragged where you want it, and most come
						in several ready-made designs.
					</p>
				</div>
			</section>

			<div className={s.cta}>
				<Button
					href={CHROME_STORE_URL}
					color="primary"
					variant="contained"
					size="large"
				>
					Add New Tab Studio to Chrome. Free
				</Button>
			</div>
		</div>
	);
}

export default withStyles(s)(Widgets);
